import React from 'react';
import { Menubar } from 'primereact/menubar';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { useHistory } from "react-router-dom";
import { connect } from 'react-redux';

const Navbar = (props) => {
    const history = useHistory()
    let items = [
        {
            label: 'Examiners', command:(e)=>{ history.push('/Examiner');  }
        },
        {
            label: 'Practical Batches', command:(e)=>{ history.push('/PRBATCHES');  }
        },
        {
            label: 'Practical City Change', command:(e)=>{ history.push('/CITYCHANGE');  }
        }

];

return (
        <Menubar tabIndex="0" style={{zIndex:'3', height:"40px", backgroundColor:"#ffe0d8"}}  model={items} /> 
    );
}
const mapStateToProps = state => {
    return {
        username:state.auth.username,
        userid:state.auth.userid,
        email:state.auth.email,
        isAuth:state.auth.token!==null,
    }
  }
export default connect(mapStateToProps)(Navbar);
